import React from 'react';
import { Section, SectionProps } from '../../components/Section/Section';
import { ContentBlock } from '@jbhi-fi/components/src/ContentBlock';
import { BreadcrumbProps, Breadcrumbs } from '../../components/Breadcrumbs/Breadcrumbs';
import { useCategoryLandingProps } from '../../hooks/content/useCategoryLandingProps';
import { HeroBlock, HeroBlockProps } from '@jbhi-fi/components/src/HeroBlock';
import { Disclaimer } from '@jbhi-fi/components/src/Disclaimer';
import { styles } from './CategoryLanding.css';
import { LegacyContentTheme } from '@jbhi-fi/components/src/Contentful/transformers/ThemeTransformer';

export type CategoryLandingProps = {
  breadcrumbs: BreadcrumbProps;
  hero?: HeroBlockProps;
  theme?: LegacyContentTheme;
  sections: Array<SectionProps>;
};

export const CategoryLanding = () => {
  const {
    data: { breadcrumbs, hero, sections, theme },
    isLoading,
    error,
  } = useCategoryLandingProps();
  const backgroundColor = theme?.backgroundColor;

  return isLoading || error ? null : (
    <>
      <Breadcrumbs className={styles.breadcrumbs} backgroundColor={backgroundColor} {...breadcrumbs} />
      <ContentBlock
        style={{ backgroundColor: theme.backgroundColor }}
        paddingBottom={{ mobile: 3.5, tablet: 10 }}
        paddingTop={0}
      >
        {hero ? <HeroBlock {...hero} /> : null}
      </ContentBlock>
      <ContentBlock
        paddingTop={0}
        paddingRight={0}
        paddingLeft={0}
        paddingBottom={{ mobile: 15, tablet: 20 }}
        maxWidth="full"
      >
        {sections.map((section, i) => (
          <Section key={i} {...section} />
        ))}
        <ContentBlock paddingTop={15} paddingBottom={0} paddingX={{ xs: 4, md: 8 }}>
          <Disclaimer disclaimers={window.Jbhifi.disclaimers} />
        </ContentBlock>
      </ContentBlock>
    </>
  );
};
